module.exports = __webpack_public_path__ + "img/norway-mental-and-behavioural-disorders-male.edc7a5b0.png";